import {createDivIn, createImgIn, createParagraphIn, createSpanIn, setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils'
import {isMobileLandscapeView, navigateToPage} from '../ui_utils/ClientUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {ViewPopup} from './ViewPopup'
import {LobbyImage} from '@colonist/types'
import {Sound} from '../Sound'
import {CA} from '../analytics/Analytics'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'

export class ViewPopupEndgameSignup extends ViewPopup {
    constructor(completedGameCount: number) {
        super({key: 'strings:game.endGame.signupPopup.title'}, {key: 'strings:colonistCommon.utils.emptyString'}, () => undefined, () => undefined, true)

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})

        const shouldMakeLarge = isMobileLandscapeView() || UIUtilsEjsVariables.isUserOnMobileApp
        if(shouldMakeLarge) this.makeLarge()

        const signupPopupWrapper = createDivIn(this.body, 'popup-signup-wrapper', '')

        createParagraphIn(signupPopupWrapper, {key: 'strings:game.endGame.signupPopup.description', options: {playedGameCount: completedGameCount}}, '')
        this.createSignupButtons(signupPopupWrapper)

        this.removeFooter()
        this.show()
    }

    private createSignupButtons(signupPopupWrapper: HTMLDivElement) {
        const signupButtonsDiv = createDivIn(signupPopupWrapper, 'popup-signup-buttons', '')

        const googleLogin = createDivIn(signupButtonsDiv, 'popup-signup-btn popup-signup-google-btn', '')
        createImgIn(googleLogin, LobbyImage.GoogleIcon)
        createSpanIn(googleLogin, '', {key: 'strings:popups.login.loginWith', options: {context: 'google'}})

        const discordLogin = createDivIn(signupButtonsDiv, 'popup-signup-btn popup-signup-discord-btn', '')
        createImgIn(discordLogin, LobbyImage.DiscordIcon)
        createSpanIn(discordLogin, '', {key: 'strings:popups.login.loginWith', options: {context: 'discord'}})

        const appleLogin = createDivIn(signupButtonsDiv, 'popup-signup-btn popup-signup-apple-btn', '')
        createImgIn(appleLogin, LobbyImage.AppleIcon)
        createSpanIn(appleLogin, '', {key: 'strings:popups.login.loginWith', options: {context: 'apple'}})

        const continueAsGuest = createDivIn(signupButtonsDiv, 'popup-signup-btn popup-signup-continue-btn', '')
        const continueAsGuestText = createSpanIn(continueAsGuest, '', {key: 'strings:popups.login.continueAsGuest'})

        setElementOnClick(googleLogin, () => {
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameSignup)
            navigateToPage(UIAPIEndpoints.googleAuth())
        })

        setElementOnClick(discordLogin, () => {
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameSignup)
            navigateToPage(UIAPIEndpoints.discordAuth())
        })

        setElementOnClick(appleLogin, () => {
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.EndGame, CA.Label.ClickedEndGameSignup)
            navigateToPage(UIAPIEndpoints.appleAuth())
        })

        setElementOnClick(continueAsGuestText, () => {
            Sound.playSound(Sound.SoundType.Click)
            this.removePopup()
        })
    }
}
